import queryString from 'query-string';

export const getResizedImageUrl = (url, options) => {
    if(!url) {
        return undefined;
    }
    return url + '?' + queryString.stringify(options);
};
